<template>
  <question-base-wrapper
    :help-text="helpText"
    question-id="date-of-insurance-start"
    :title="title || 'When would you like your insurance to start?'"
    :subtitle="formRowTitle"
    v-bind="baseWrapperProps"
  >
    <date-picker-menu
      v-model="dateOfInsurance"
      :datepicker-label-format="datepickerLabelFormat"
      :step-id="stepId"
      :field-tracker-id="fieldTrackerId"
    />
  </question-base-wrapper>
</template>

<script>
import {
  UtcDate,
  ExtDate,
  DATEPICKER_LABEL_FORMAT,
} from '@/helpers/date';
import DatePickerMenu from '@/components/DatePickerMenu.vue';

import QuestionBase from './Base';
import { snakeCase } from 'lodash';

export default {
  name: 'question-date-of-insurance-start',
  extends: QuestionBase,
  components: {
    DatePickerMenu,
  },
  inject: [
    'helpers',
  ],
  props: {
    question: {
      type: String,
      default: '',
      required: false,
    },
    datepickerLabelFormat: {
      type: String,
      default: DATEPICKER_LABEL_FORMAT,
    },
  },
  data () {
    return {
      fields: ['dateOfInsuranceStart'],
      dateOfInsurance: '',
      showDateOfInsuranceStartDatepicker: false,
    };
  },
  computed: {
    questionLabel () {
      if (this.question) return this.question;

      return `Your cover start date must be within ${this.constants.DATE_OF_INSURANCE_START_MAX_DAYS} days of today.`;
    },
    questionDataValue () {
      return this.questionData[this.questionFields.dateOfInsuranceStart];
    },
    formRowTitle () {
      return this.subtitle || this.questionLabel;
    },
    fieldTrackerId () {
      return snakeCase(this.questionFields.dateOfInsuranceStart);
    },
  },
  created () {
    this.$watch('dateOfInsurance', val => {
      this.questionData[this.questionFields.dateOfInsuranceStart] = val;
    });

    this.$watch('questionDataValue', val => {
      if (val) {
        const insuranceDateBeforeMinPossible = new UtcDate(val).isBefore(new UtcDate(this.dateOfInsuranceMin));

        if (insuranceDateBeforeMinPossible) {
          this.questionData[this.questionFields.dateOfInsuranceStart] = null;
        }
      }
      this.dateOfInsurance = this.questionData[this.questionFields.dateOfInsuranceStart];
    }, { immediate: true });
  },
  setup () {
    const today = new ExtDate();
    const todayUtc = new UtcDate();

    // if GTM shift is ahead of UTC date - set min date to today
    const dateOfInsuranceMin = today.isAfter(todayUtc) ? today.format() : todayUtc.format();

    return {
      today,
      dateOfInsuranceMin,
    };
  },
};
</script>
